import { combineReducers } from 'redux';

import security from './security';

const rootReducer = combineReducers({ security });

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js